import React from "react";
import ReactDOM from "react-dom";

import "./assets/scss/material-dashboard-pro-react.css?v=1.3.0";
import "./assets/scss/app.css";
import "./assets/scss/app-survey.css";
import "./assets/scss/animation.css";
import "./assets/scss/front-tab.css";

import Store from './store'
import Routes from "./routes/index.jsx";

import Highcharts from 'highcharts' 
require('highcharts/modules/exporting')(Highcharts);
require('highcharts/modules/export-data')(Highcharts);

ReactDOM.render(<Store routers={Routes} />,document.getElementById("root"));